import React from "react";
import { useTranslation } from "react-i18next";

import { Typography, MenuItem } from "@mui/material";

import { Props } from "../interfaces";
import { Container, Select } from "../styles";

export const monthsValues = [
  { value: 0, key: "months.january" },
  { value: 1, key: "months.february" },
  { value: 2, key: "months.march" },
  { value: 3, key: "months.april" },
  { value: 4, key: "months.may" },
  { value: 5, key: "months.june" },
  { value: 6, key: "months.july" },
  { value: 7, key: "months.august" },
  { value: 8, key: "months.september" },
  { value: 9, key: "months.october" },
  { value: 10, key: "months.november" },
  { value: 11, key: "months.december" },
];

const CustomDropdownMonthsValues = ({
  label,
  value,
  handleChangeValue,
  handleChangeMultipleValue,
  smallerInputStyles,
  isMultiselect,
  withoutLabel = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Container>
      {!withoutLabel && <Typography>{label}</Typography>}
      <Select
        value={value}
        onChange={({ target: { value } }) => {
          isMultiselect && handleChangeMultipleValue
            ? handleChangeMultipleValue(value as number[])
            : !isMultiselect && handleChangeValue && handleChangeValue(value as number);
        }}
        smallerInputStyles={smallerInputStyles}
        width={200}
        multiple={isMultiselect}
      >
        {monthsValues.map(({ value, key }) => (
          <MenuItem
            key={value}
            value={value}
          >
            {t(key)}
          </MenuItem>
        ))}
      </Select>
    </Container>
  );
};

export default CustomDropdownMonthsValues;
